<template>
  <div id="register">
    <!-- <div class="register-content__tab mar-b-30">
      <div :class="['register-content__tab__item ipub-h3']">
        <router-link to="login">Sign In</router-link>
      </div>
      <div :class="['register-content__tab__item ipub-h3 mar-l-40 active']">
        <template>Sign Up</template>
      </div>
    </div> -->
    <ipub-form ref="register-form"
               :model="form"
               :rules="rules">
      <ipub-form-item prop="email"
                      label="Email">
        <ipub-input v-model.trim="form.email"
                    placeholder="Email" />
      </ipub-form-item>
      <ipub-form-item prop="password"
                      label="">
        <div class="mar-b-10 ipub-p2 fw-bd relative ipub-cursor-pointer"
             slot="label">
          Password<font class="key-color">*</font>
          <ipub-tooltip placement="right"
                        type="dark"
                        action="click"
                        class="mar-l-10">
            <div slot="title">1. Password can be a combination of 6-20 digits, letters, and punctuations, but not spaces.<br />
              2. Include at least two numbers, letters, and punctuations.<br />
              3. Letters are case sensitive.</div>
            <ipub-icon style="display:inline-block"
                       type="iconInfo" />
          </ipub-tooltip>
        </div>
        <ipub-input password
                    v-model.trim="form.password"
                    placeholder="Password" />

      </ipub-form-item>
      <ipub-form-item prop="cpassword"
                      style="margin-bottom:24px"
                      label="Confirm Password">
        <ipub-input password
                    v-model.trim="form.cpassword"
                    placeholder="Confirm Password" />
      </ipub-form-item>
      <ipub-form-item prop="code">
        <div class="flex-center">
          <ipub-input v-model.trim="form.code"
                      style="width:50%"
                      placeholder="Verification Code" />
          <img :src="code.code"
               @click="getCaptcha"
               class="ipub-c-p"
               style="width:calc(50% - 70px);height:40px;margin:0 10px"
               alt="">
          <a @click="getCaptcha"
             class="link-color">Refresh</a>
        </div>
      </ipub-form-item>
    </ipub-form>
    <div class="mar-b-12">
      <ipub-radio :checked="isChecked"
                  @change="isChecked=!isChecked">
        <div>
          I agree with <a href="/privacy-policy"
             target="_blank"
             class="link-color"> {{publisherInfo.fullName}} service policy</a>
        </div>
      </ipub-radio>
    </div>
    <ipub-button style="width:100%;margin-bottom:12px"
                 type="primary"
                 :disabled="!isChecked"
                 @click="submit">
      Sign Up
    </ipub-button>
    <div class="ipub-p3 font-color">Already have an account.
      <router-link class="link-color"
                   to="login">Sign In</router-link>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
